var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2186_50606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 4.49701C15.3867 3.85069 15.1606 3.26019 14.8047 2.77344",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30833 0.570312C4.75671 0.813891 4.26561 1.21221 3.90625 1.75104",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67688 13.8242L3.2816 13.3743C2.73303 12.7501 2.3025 12.0314 2.01098 11.2532L1.22546 9.15629C1.03095 8.63708 1.19514 8.05169 1.63127 7.70934C2.28543 7.19586 3.24828 7.43781 3.58198 8.19954L4.2454 9.71384C4.74253 9.84705 5.88237 10.3656 6.46464 11.3741",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24609 9.72006L5.91118 3.5059C6.0951 2.81951 6.80063 2.41218 7.48702 2.5961C8.17342 2.78 8.58076 3.48554 8.39684 4.17194M8.39684 4.17194L7.3978 7.90043M8.39684 4.17194L8.79646 2.68054C8.98038 1.99414 9.68591 1.5868 10.3723 1.77072C11.0587 1.95464 11.4661 2.66018 11.2821 3.34658L10.6161 5.83223M10.6161 5.83223L9.75025 9.06359M10.6161 5.83223C10.8 5.14583 11.5055 4.7385 12.1919 4.92242C12.8783 5.10634 13.2856 5.81187 13.1017 6.49827L11.1489 13.7864C10.992 14.3719 10.6089 14.8712 10.0839 15.1743L9.64317 15.4288",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2186_50606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/hands.b1a879ad6c06147ed68be5612ad8c5e1.svg";
export { ForwardRef as ReactComponent };